import { constants } from "@newsela/angelou";

const { colors } = constants;

export const rootCss = (isVideoPresentModeActive) => ({
  backgroundColor: colors.ui.white[500],
  borderBottom: `1px solid ${colors.ui.neutral[100]}`,
  display: isVideoPresentModeActive && "none",
});
